// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
export const getMessage = state => state.confirmOrderReducer.message;
export const getPaymentType = state => state.confirmOrderReducer.paymentType;
export const getTotal = state => state.confirmOrderReducer.total;
export const getIsCollectionArranged = state => state.confirmOrderReducer.isCollectionArranged;
export const getCharities = state => state.confirmOrderReducer.charities;
export const getCharityId = state => state.confirmOrderReducer.charityId;
